import { render, staticRenderFns } from "./CsvUpload.vue?vue&type=template&id=3da5dc5a&scoped=true&"
import script from "./CsvUpload.vue?vue&type=script&lang=js&"
export * from "./CsvUpload.vue?vue&type=script&lang=js&"
import style0 from "./CsvUpload.vue?vue&type=style&index=0&id=3da5dc5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da5dc5a",
  null
  
)

export default component.exports